import React from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { ShieldExclamation } from "react-bootstrap-icons";
import ReactGA from "react-ga4";

export const CyberRiskDisclaimer = () => {
    ReactGA.initialize("G-ECGH6LJ63Y");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    return (
        <Container fluid style={{ backgroundColor: "#f9f9fb", padding: "4rem 2rem" }}>
            <h1 style={{ textAlign: "center", color: "#1e1e3f", fontWeight: "700", marginBottom: "2rem" }}>
                Cyber Risk Disclaimer
            </h1>

            <Container style={{ maxWidth: "800px" }}>
                <Alert
                    variant="warning"
                    style={{
                        backgroundColor: "#fff3cd",
                        borderColor: "#ffeeba",
                        color: "#856404",
                        borderRadius: "10px",
                        padding: "2rem",
                        boxShadow: "0 6px 20px rgba(0, 0, 0, 0.05)",
                        lineHeight: "1.6",
                        fontSize: "1.05rem",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                        <ShieldExclamation size={28} className="me-3" />
                        <strong style={{ fontSize: "1.25rem" }}>CYBER RISK WARNING</strong>
                    </div>

                    <p>
                        Please be aware that there is a significant risk posed by cyber fraud, specifically affecting email accounts and bank account details.
                    </p>
                    <p>
                        It is imperative that you verify all banking details received and sent. Prior to making any payment, please verify the banking details directly with us or the product provider.
                    </p>
                    <p>
                        When calling us or a product provider, please ensure that the phone number you dial is a known and trusted number. For insurer claim payments, kindly ensure that we have received your correct banking details.
                    </p>
                    <p>
                        Do not respond to any e-mails notifying you of a change in banking details. We will not be liable for any losses or damages that may be suffered directly or indirectly as a result of any cyber fraud, cybercrime or business e-mail compromise.
                    </p>
                </Alert>
            </Container>
        </Container>
    );
};